import { microApi } from 'app/services/api';
import { ListResponse } from 'app/types';
import qs from 'qs';
import pick from 'lodash/pick';

const END_POINTS = 'admin/inspections/inspectors';
export const templatesApi = microApi.injectEndpoints({
  endpoints: (build) => ({
    getInspectors: build.query<
      {
        data: Array<any>;
        pagination: {
          page: number;
          pageSize: number;
          pages: number;
          total: number;
        };
      },
      {
        current: number;
        pageSize: number;
        isEnabled?: any;
        name?: any;
        email?: any;
        keywords?: string;
      }
    >({
      query: (params) => {
        const queryString = qs.stringify(
          {
            pageNo: params.current,
            pageSize: params.pageSize,
            ...pick(params, [
              'isEnabled',
              'name',
              'email',
              'status',
              'keywords'
            ])
          },
          {
            encodeValuesOnly: false,
            indices: false
          }
        );
        return {
          url: `/${END_POINTS}${queryString ? '?' + queryString : ''}`,
          method: 'GET'
        };
      },
      transformResponse: (baseQueryReturnValue: ListResponse<any>) => {
        return {
          pagination: baseQueryReturnValue.data.pagination,
          data: baseQueryReturnValue.data.list
        };
      }
    }),
    createInspector: build.mutation({
      query: (data) => {
        return {
          url: `/${END_POINTS}`,
          method: 'POST',
          body: data
        };
      }
    }),
    updateInspector: build.mutation<
      any,
      {
        inspectorId: string;
        data: any;
      }
    >({
      query: (params) => {
        return {
          url: `/${END_POINTS}/${params.inspectorId}`,
          method: 'PUT',
          body: params.data
        };
      }
    }),
    getInspector: build.query({
      query: (inspectorId: string) => {
        return {
          url: `/${END_POINTS}/${inspectorId}`,
          method: 'GET'
        };
      }
    }),
    disableInspector: build.mutation({
      query: (inspectorId) => {
        return {
          url: `/${END_POINTS}/${inspectorId}/disable`,
          method: 'POST',
          body: {}
        };
      }
    }),
    activeInspector: build.mutation({
      query: (inspectorId) => {
        return {
          url: `/${END_POINTS}/${inspectorId}/active`,
          method: 'POST',
          body: {}
        };
      }
    }),
    inactiveInspector: build.mutation({
      query: (inspectorId) => {
        return {
          url: `/${END_POINTS}/${inspectorId}/inactive`,
          method: 'POST',
          body: {}
        };
      }
    })
  })
});

export const {
  useLazyGetInspectorsQuery,
  useCreateInspectorMutation,
  useLazyGetInspectorQuery,
  useUpdateInspectorMutation,
  useDisableInspectorMutation,
  useActiveInspectorMutation,
  useInactiveInspectorMutation
} = templatesApi;
